/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Drastic_Tech_Embed_Complete_LogInputs */

const en_drastic_tech_embed_complete_log = /** @type {(inputs: Drastic_Tech_Embed_Complete_LogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`-----Embedding closed caption process complete-----`)
};

const fr_drastic_tech_embed_complete_log = /** @type {(inputs: Drastic_Tech_Embed_Complete_LogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`-----Processus d'integration termine-----`)
};

const de_drastic_tech_embed_complete_log = /** @type {(inputs: Drastic_Tech_Embed_Complete_LogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`-----Einbettung der Untertitel abgeschlossen-----`)
};

const it_drastic_tech_embed_complete_log = /** @type {(inputs: Drastic_Tech_Embed_Complete_LogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`-----Processo di incorporamento dei sottotitoli completato-----`)
};

const ru_drastic_tech_embed_complete_log = /** @type {(inputs: Drastic_Tech_Embed_Complete_LogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`-----Процесс встраивания субтитров завершен-----`)
};

const es_drastic_tech_embed_complete_log = /** @type {(inputs: Drastic_Tech_Embed_Complete_LogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`-----Proceso de incrustación de subtítulos completo-----`)
};

const zh_cn2_drastic_tech_embed_complete_log = /** @type {(inputs: Drastic_Tech_Embed_Complete_LogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`-----嵌入字幕过程完成-----`)
};

const ja_drastic_tech_embed_complete_log = /** @type {(inputs: Drastic_Tech_Embed_Complete_LogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`-----字幕埋め込み処理が完了しました-----`)
};

const hi_drastic_tech_embed_complete_log = /** @type {(inputs: Drastic_Tech_Embed_Complete_LogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`-----क्लोज्ड कैप्शन एम्बेड करने की प्रक्रिया पूरी हो गई-----`)
};

const pt_pt2_drastic_tech_embed_complete_log = /** @type {(inputs: Drastic_Tech_Embed_Complete_LogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`-----Processo de incorporação de legendas concluído-----`)
};

/**
* | output |
* | --- |
* | "-----Embedding closed caption process complete-----" |
*
* @param {Drastic_Tech_Embed_Complete_LogInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const drastic_tech_embed_complete_log = /** @type {((inputs?: Drastic_Tech_Embed_Complete_LogInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Drastic_Tech_Embed_Complete_LogInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_drastic_tech_embed_complete_log(inputs)
	if (locale === "de") return de_drastic_tech_embed_complete_log(inputs)
	if (locale === "it") return it_drastic_tech_embed_complete_log(inputs)
	if (locale === "ru") return ru_drastic_tech_embed_complete_log(inputs)
	if (locale === "es") return es_drastic_tech_embed_complete_log(inputs)
	if (locale === "zh-CN") return zh_cn2_drastic_tech_embed_complete_log(inputs)
	if (locale === "ja") return ja_drastic_tech_embed_complete_log(inputs)
	if (locale === "hi") return hi_drastic_tech_embed_complete_log(inputs)
	if (locale === "pt-PT") return pt_pt2_drastic_tech_embed_complete_log(inputs)
	return en_drastic_tech_embed_complete_log(inputs)
});